export const CODELESS_CATEGORIES = [
    {
        value: 'VIEW_CONTENT',
        label: 'View Content',
    },
    {
        value: 'SEARCH',
        label: 'Search',
    },
    {
        value: 'ADD_TO_CART',
        label: 'Add to Cart',
    },
    {
        value: 'ADD_TO_WISHLIST',
        label: 'Add to Wishlist',
    },
    {
        value: 'START_CHECKOUT',
        label: 'Start Checkout',
    },
    {
        value: 'ADD_PAYMENT_INFO',
        label: 'Add Payment Info',
    },
    {
        value: 'MAKE_PURCHASE',
        label: 'Make Purchase',
    },
    {
        value: 'LEAD',
        label: 'Lead',
    },
    {
        value: 'COMPLETE_REGISTRATION',
        label: 'Complete Registration',
    },
    {
        value: 'APP_INSTALL',
        label: 'App Install',
    },
    {
        value: 'OTHER',
        label: 'Other',
    },
    {
        value: 'SIGNUP',
        label: 'Sign Up',
    },
    {
        value: 'CONTACT',
        label: 'Contact',
    },
    {
        value: 'SUBSCRIBE',
        label: 'Subscribe',
    },
];
